<template>
  <router-view></router-view>
</template>
<script>
import moment from "moment";

export default {

  data: () => ({}),

  created() {
    window.addEventListener("resize", this.resizeHandler);
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeHandler);
  },

  mounted() {

    // Get current time
    const nowt = moment();

    // Get start day
    const sd = (nowt.diff(moment(0), 'days') - 49) - nowt.weekday();

    // Set Gant params
    this.$dispatch("misc/var", {name: "show-task-details", val: 0});
    this.$dispatch("misc/var", {name: "gantt-grid-size", val: 30});
    this.$dispatch("misc/var", {name: "gantt-days-offset", val: -49});
    this.$dispatch("misc/var", {name: "gantt-start-day", val: sd});
    this.$dispatch("misc/var", {name: "gantt-end-day", val: moment().diff(moment(0), 'days') + 350});

    // Manual call resize handler
    this.resizeHandler();
  },

  computed: {
    cssVars() {
      return {}
    }
  },

  methods: {
    resizeHandler() {
      // Window size
      this.$dispatch("misc/var", {name: "window-width", val: window.innerWidth});
      this.$dispatch("misc/var", {name: "window-height", val: window.innerHeight});
    }
  }
}
</script>
